import React from 'react';
import './MobileNotAvailableWarning.css';
import { getTranslation } from '../../assets/creator/translations';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import '../../containers/Sidebar/SidebarStyleMenu.css'

const MobileNotAvailableWarning = ({lang, langChangeHandler}) => (
    <div className="mobile-not-available-warning">
        <div className="mobile-not-available-warning__mobile-logo-wrapper">
            <img src="./img/comarch_logo_mobile_browsers.svg" className="mobile-logo" alt="logo" />
        </div>
        <div className="mobile-not-available-warning__container">
            <p className="mobile-not-available-warning__title">
                {getTranslation("MobileNotAvailable")}
            </p>
            <p className="mobile-not-available-warning__content">
                {getTranslation("OpenOnBiggerScreen")}
            </p>
        </div>
        <LanguageSelector lang={lang} langChangeHandler={langChangeHandler}/>
    </div>
);
export default MobileNotAvailableWarning;


// WEBPACK FOOTER //
// ./src/components/MobileNotAvailableWarning/MobileNotAvailableWarning.js